/**
 * Canonical member-referral promise + attribution window.
 *
 * Reward: docs/design/affiliate-program-2026-08-23.md
 * Attribution cookie remains 90 days; that is not the reward.
 */
export const REFERRAL_PROGRAM_PROMISE =
  "Refer 3 paying members → 1 month free. Friends pay full price.";

export const REFERRAL_REVENUE_SHARE_DAYS = 90;

/** Short funnel window label, e.g. "last 90d". */
export const REFERRAL_FUNNEL_WINDOW_LABEL = `last ${REFERRAL_REVENUE_SHARE_DAYS}d`;

/** Attribution-window phrase (cookie / funnel), not the member reward. */
export const REFERRAL_REVENUE_SHARE_COPY = `${REFERRAL_REVENUE_SHARE_DAYS}-day revenue share`;

/** First-glance explainer on the /rewards share block. */
export const REFERRAL_SHARE_EXPLAINER = REFERRAL_PROGRAM_PROMISE;
